import { Divider, Flex, Text } from "@chakra-ui/react";
import { PaymentCard } from "@components/card";
import styled from "@emotion/styled";
import { usePaymentRoomState } from "@shared/client";
import { MEDIA } from "@styles/common";
import theme from "@styles/theme";
import { useEffect } from "react";
import { SelectListProps } from "./selectedRooms.type";

export const SelectedRooms = ({ data }: SelectListProps) => {
    const [paidRoomValue, setPaidRoomValue] = usePaymentRoomState();
    const totalPrice = paidRoomValue.reduce((acc, item) => acc + item.finalPrice, 0);
    const { isMobile } = MEDIA();

    useEffect(() => {
        setPaidRoomValue(data.map((it) => it.paidRooms));
    }, []);

    return (
        <Flex width="100%" flexDir="column" gap="16px">
            <Flex width="100%" flexDir="column" gap="24px">
                {paidRoomValue.length > 0 &&
                    paidRoomValue.map((it) => {
                        return (
                            <>
                                <PaymentCard key={it.roomIdx} {...it} />
                                <CustomDivider />
                            </>
                        );
                    })}
            </Flex>
            {totalPrice && (
                <Flex w="100%" justifyContent={isMobile ? "flex-start" : "flex-end"}>
                    <Flex alignItems="center" width={"100%"} justifyContent="space-between">
                        <Text>총 결제금액</Text>
                        <Flex alignItems="center" gap="4px">
                            <Text fontSize="24px" color={theme.COLOR.pink[200]} fontWeight="500">
                                {totalPrice.toLocaleString()}
                            </Text>
                            <Text>원</Text>
                        </Flex>
                    </Flex>
                </Flex>
            )}
        </Flex>
    );
};

const CustomDivider = styled(Divider)`
    color: ${({ theme }) => theme.COLOR.gray[300]};
`;
